<template>
  <div class="EditAddress">
    <ld-header transparent>
      <span
        v-if="id"
        slot="right"
        @click="del"
      >删除</span>
    </ld-header>

    <div class="wrap">
      <van-cell-group :title="`${id ? '编辑' : '新增'}常用地址`">
        <van-field
          v-model="detail.recipient"
          required
          label="收件人"
          placeholder="请填写收件人姓名"
        />
        <van-field
          v-model="detail.phoneNumber"
          required
          :label="$t('F008','手机号')"
          placeholder="请输入收件人手机号"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          label="所在地区"
          required
          readonly
          clickable
          @click="provincePopup = true"
          :value="`${detail.cName || ''}  ${detail.cityName || ''}`"
        />
        <LdArea
          :visibility.sync="provincePopup"
          @confirm="provinceSelect"
        />

        <van-field
          v-model="detail.addr"
          required
          label="详细地址"
          placeholder="街道、楼牌号、单元室等"
        />
        <van-field
          v-model="detail.post"
          label="邮政编码"
          placeholder="请输入该地区邮政编码"
        />
      </van-cell-group>

      <van-cell-group>
        <van-cell title="设为默认地址">
          <van-switch
            class="fr"
            v-model="detail.isDefault"
            size="24px"
          />
        </van-cell>
      </van-cell-group>

      <div class="font12 gray wrap">
        如需完善员工详细资料，请联系管理员进行处理
      </div>
    </div>

    <div class="submit-btn__wrap">
      <ld-button
        style="margin-top: 5px;"
        @click="save"
        main3
        size="lg"
      >
        {{ $t('B010','保存') }}
      </ld-button>
    </div>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Switch, Divider } from 'vant'
import ldButton from 'Common/ldButton'
import LdArea from 'Common/ldArea'
import addressInteractor from 'Domain/use-cases/address-interactor'
import { validators } from 'Utils/valid'

export default {
  name: 'EditAddress',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Divider.name]: Divider,
    LdArea, ldButton
  },
  props: {
    id: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      detail: {},
      provincePopup: false,
      isRouterComponent: true
    }
  },
  async created() {
    // 判断是否为路由组件
    this.isRouterComponent = this.$parent.$el === this.$root.$el

    if (this.id) this.query()
  },
  methods: {
    provinceSelect (picker) {
      this.detail.cName = picker[0]
      this.detail.cityName = picker[1].cityName

      this.detail.province = picker[1].provinceId
      this.detail.city = picker[1].cityId
    },
    async query() {
      let { data } = await addressInteractor.getAddressById(this.id)
      this.detail = data
    },
    async save() {
      if (!this.detail.recipient) {
        this.$validErrorTips('请输入收件人姓名！')
      } else if (!validators.mobile(this.detail.phoneNumber).valid) {
        this.$validErrorTips(validators.mobile(this.detail.phoneNumber).msg)
      } else if (!this.detail.city || !this.detail.province) {
        this.$validErrorTips('请输入所在地区！')
      } else if (!this.detail.addr) {
        this.$validErrorTips('请输入详细地址！')
      } else {
        await addressInteractor.saveAddress(this.detail)
        
        this.$dialog.alert({
          message: '保存成功'
        }).then(() => {
          this.back()
        })
      }
    },
    /**
     * 删除常用地址
     */
    del () {
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(async () => {
        await addressInteractor.deleteAddress(this.id)
        this.$dialog({ message: '删除成功！' }).then(() => {
          this.back()
        })
      })
    },
    back () {
      if (this.isRouterComponent) {
        this.$router.go(-1)
      } else {
        this.$emit('submit', this.detail)
      }
    }
  }
}
</script>

<style lang="less">
.EditAddress {
  .wrap {
    padding: 10px;
  }

  .submit-btn__wrap {
    padding: 0 37px;
    margin: 0 auto 10px;
  }

  .van-cell-group__title {
    padding-top: 0;
    font-size: @font-size-20;
    letter-spacing: 1px;
    color: @color-text-black;
  }

  .van-cell-group {
    margin-top: 5px;
  }
}
</style>

